/*eslint no-console: 0*/
import config from '../../../lib/config'
import PageMixins from '../../../components/_mixins/pages'

import MainService from '../../../services/main'
import {
  ValidationMixins,
  passwordRules,
  passwordConfirmationRules,
  setValidationRule,
  parseValidations,
  parseValidationSetup,
} from '../../../lib/validations'

const validations = {
  old_password: setValidationRule('old_password'),
  password: setValidationRule('password', passwordRules),
  password_confirmation: setValidationRule('password_confirmation', passwordConfirmationRules),
}

export default {
  name: 'reset-password-prompt',
  mixins: [ValidationMixins, PageMixins],
  props: ['userId'],
  components: {},
  data() {
    return {
      sendingRequest: false,
      requestSentError: '',
      old_password: '',
      password: '',
      password_confirmation: '',
      validations,
      formElements: [
        'old_password', 'password', 'password_confirmation'
      ]
    }
  },
  validations: parseValidations(validations),
  created() {
  },
  mounted() {
    this.$v.$reset()
    this.requestSentError = ''
  },
  computed: {
  },
  methods: {
    async submit() {

      this.$v.$touch()
      this.formSubmitting = true
      if (!this.isAnyInvalid) {
        this.requestSentError = null
        const payload = _.pick(this, this.formElements)
        this.sendingRequest = true
        // console.log(payload)
        try {
          const data = await MainService.updateUser(this.userId, payload)
          this.$emit('success')
          this.showResetPassword(false)
        } catch (e) {
          this.requestSentError = MainService.getFirstErrorMessage(e)
          this.$emit('error', e)
        } finally {
          this.sendingRequest = false
        }
      }
    },
  }
}
